<!--
 * @Author: pengyong
 * @Date: 2020-11-15 17:14:46
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-01 23:46:34
 * @Description: 注册登录通用按钮
 * @FilePath: /exhibit/src/components/CommonButton/index.vue
-->
<template>
    <!-- <div :class="['button', disabled && 'disabled']" v-loading="loading" @click="handleClick">
        <slot></slot>
    </div> -->
    <el-button
        :class="['button', disabled && 'disabled']"
        :style="{ height: height, lineHeight: height, fontSize: fontSize }"
        type="primary"
        :disabled="disabled"
        :loading="loading"
        @click="handleClick"
    >
        <slot></slot>
    </el-button>
</template>

<script>
export default {
    props: {
        disabled: false,
        loading: false,
        height: {
            type: String,
            default: "40px"
        },
        fontSize: {
            type: String,
            default: "16px"
        }
    },
    methods: {
        handleClick() {
            if (!this.disabled) {
                this.$emit("click");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.button {
    width: 100%;
    background: #0D5095;
    border-radius: 20px;
    text-align: center;
    color: #ffffff;
    padding: 0;
    cursor: pointer;
    border: none;
    font-weight: 600;
    &.disabled {
        background: rgba(9, 70, 140, 0.2);
        cursor: not-allowed;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonButton/index.vue